export const msalConfig = {
    auth: {
        clientId: "6fd3dc7b-deae-42a9-9301-1594bce26820",
        authority: "https://login.microsoftonline.com/2b79a395-e041-4723-8c0d-be105a656b5b",
        redirectUri: window.location.origin
    }
}